<ng-container *ngIf="state$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ (data.id ? 'app.dialog.planned-purchase-price.title-update.header' : 'app.dialog.planned-purchase-price.title-create.header') | translate}}
    </h1>
    <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
    <div mat-dialog-content>
        <mat-generic-input
            [fields]="layout.fields"
            (inputFormGroupChange)="onFormGroupChange($event)"
            [initialValue]="initialData | async">
        </mat-generic-input>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button
            [disabled]="!(dialogFieldsValid$ | async) || state.isLoading"
            mat-flat-button
            color="primary"
            (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
